class HomeBanner {
    constructor() {
        this.section = document.getElementById('home-banner');
        if (!this.section) return;
        
        this.swiperEl = this.section.querySelector('.swiper');
        if (!this.swiperEl || typeof Swiper === 'undefined') return;
        
        this.init();
    }
    
    init() {
        this.swiper = new Swiper(this.swiperEl, {
            slidesPerView: 1,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            allowTouchMove: false,
            speed: 800,
            autoplay: {
                delay: 8000,
                disableOnInteraction: false,
                pauseOnMouseEnter: false
            },
            on: {
                init: () => this.resizeBgVideo(),
                slideChangeTransitionEnd: () => {
                    this.resizeBgVideo();
                }
            }
        });
    }
    
    resizeBgVideo() {
        jQuery(window).trigger('resize.bg-video');
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new HomeBanner();
});